import styled from "styled-components";

import { SmallPrint } from "../typography/SmallPrint.styled";

const InputLabel = styled(SmallPrint)`
  background-color: ${({ theme }) => theme.colors.baseWhite};
  color: ${({ theme }) => theme.colors.base5};
`;

export default InputLabel;
